import type { AppProps } from "next/app";
import Head from "next/head";

import { Provider } from "react-redux";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";

import Banner from "@components/Banner";

import "../styles/globals.scss";
import "@rainbow-me/rainbowkit/styles.css";

import { getCustomTheme } from "../theme";

import { store } from "../store";
import RudderStackScript from "@components/RudderStackScript";
import AnalyticsMapping from "@constants/analytics_mapping.json";

import WagmiProvier from "@services/WagmiProvider";

import useLedgerCookies from "@hooks/useLedgerCookies";
import { useEffect, useState } from "react";

const colors = {
  myScheme: {
    50: "#daffff",
    100: "#b1fbfb",
    200: "#85f7f7",
    300: "#58f3f3",
    400: "#31f0f0",
    500: "#1ed7d7",
    600: "#0ca7a7",
    700: "#007777",
    800: "#004949",
    900: "#001a1a",
  },
};

export const theme = extendTheme({ colors });

const DefaultHead = () => {
  return (
    <Head>
      <RudderStackScript fileName={AnalyticsMapping["fileName"]} />
    </Head>
  );
};

function MyApp({ Component, pageProps }: AppProps) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useLedgerCookies();

  if (!isClient) {
    return null;
  }
  return (
    <>
      <DefaultHead />
      <ChakraProvider theme={getCustomTheme()}>
        <Banner />
        <Provider store={store}>
          <WagmiProvier>
            <Component {...pageProps} suppressHydrationWarning />
          </WagmiProvier>
        </Provider>
      </ChakraProvider>
    </>
  );
}

export default MyApp;
